import { get, post, del } from './client';

export const listarMensagens = (params = {}) => {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([chave, valor]) => {
    if (valor !== undefined && valor !== null && valor !== '') query.set(chave, valor);
  });
  const qs = query.toString();
  return get(`/mensagens${qs ? `?${qs}` : ''}`);
};

export const criarMensagem = (payload) => post('/mensagens', payload);
export const removerMensagem = (id) => del(`/mensagens/${id}`);
